<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <template #right>
            <CreateAvailabilityButton :browserTimeZone="browserTimeZone" />
        </template>

        <div>
            <div class="grid grid-cols-12 gap-4">
                <template
                    v-for="availability in localAvailabilities"
                    :key="availability.id.value"
                >
                    <div class="col-span-12 lg:col-span-4">
                        <AvailabilityCard
                            :availability="availability"
                            :defaultAvailabilityId="
                                localCompany.defaultAvailabilityId
                            "
                            :companyUser="authCompanyUser"
                            @onAvailabilityUpdated="
                                handleAvailabilityUpdated($event.availability)
                            "
                            @onAvailabilityDeleted="
                                handleAvailabilityDeleted(availability)
                            "
                            @onDefaultAvailabilityUpdated="
                                handleDefaultAvailabilityUpdated($event.company)
                            "
                        />
                    </div>
                </template>
            </div>
        </div>
    </AppLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import Company from '@/App/Company/Entity/Company'
    import Availability from '@/App/Availability/Entity/Availability'
    import AvailabilityCard from '@/App/Availability/Component/AvailabilityCard.vue'
    import CreateAvailabilityButton from '@/App/Availability/Component/CreateAvailabilityButton.vue'
    import { type PageMeta } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import useDate from '@/Shared/Hook/useDate'

    interface AvailabilityIndexPageProps {
        pageMeta: PageMeta
        appSharedDataData: any
        availabilitiesData: any
    }

    const props = defineProps<AvailabilityIndexPageProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const authCompanyUser = appSharedData.getAuthCompanyUser()
    const localCompany = ref<Company>(appSharedData.getAuthCompany())
    const localAvailabilities = ref<Availability[]>(
        Availability.hydrateMultiple(props.availabilitiesData),
    )
    const browserTimeZone = useDate().getBrowserTimeZone()

    const handleAvailabilityUpdated = (updatedAvailability: Availability) => {
        localAvailabilities.value = localAvailabilities.value.map(
            (availability: Availability) => {
                return updatedAvailability.id.value === availability.id.value
                    ? updatedAvailability
                    : availability
            },
        )
    }

    const handleAvailabilityDeleted = (deletedAvailability: Availability) => {
        localAvailabilities.value = localAvailabilities.value.filter(
            (availability: Availability) => {
                return deletedAvailability.id.value !== availability.id.value
            },
        )
    }

    const handleDefaultAvailabilityUpdated = (company: Company): void => {
        localCompany.value = company
    }
</script>
